
import React, { JSX } from 'react'
import { ContactForm } from 'components/ContactForm'

export const SupportPage = (): JSX.Element => (
  <div className='mx-auto w-full max-w-3xl px-6 py-10'>
    <h1 className='text-2xl font-bold text-dm-text-primary'>Contact Us</h1>
    <p className='mt-3 text-sm leading-relaxed text-dm-text-secondary'>
      Questions, feedback, or need to report a bug? Send us a message
      and we will get back to you by email.
    </p>
    <ContactForm />
  </div>
)

export default SupportPage
